
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {}
})
export default class NotFound extends Vue {
  @Prop({
    type: String,
    default: ""
  })
  text!: string; //主要文字
  @Prop({
    type: String,
    default: ""
  })
  textSmall!: string; //次要文字（暂无）
}
